import { useEffect } from 'react';
import { useAppHeader } from 'AppHeaderReact';

/*
    The completion screen hides the app header and paints the page blue, then puts both back on the way
    out. Mirrors the $watch and the $destroy handler in stream_completed_dir.js.

    `completion-blue` is a body class, defined outside this module, that carries the blue and its hexagon
    pattern. setBodyBackground with no argument restores the default, which is what the old code did.
*/
export function useStreamCompletedHeader() {
    const { toggleVisibility, setBodyBackground } = useAppHeader();

    useEffect(() => {
        toggleVisibility(false);
        setBodyBackground('completion-blue');

        return () => {
            toggleVisibility(true);
            setBodyBackground();
        };
    }, [toggleVisibility, setBodyBackground]);
}
